import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { roadmap } from '@/mocks/smart-restaurant';

export default function Roadmap() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="实施路径"
          title="诊断 → 上线 → 协同 → 增长 → 复制"
          subtitle="先梳理门店、组织、商品、供应商、订单和结算，再优先打通商品、订单、收银、KDS、库存，逐步接入供应链、权益和数据治理。"
        />

        {/* 桌面端：横向五步 */}
        <div className="hidden lg:block mt-14">
          <div className="relative">
            <div className="absolute top-6 left-0 right-0 h-px bg-background-300"></div>
            <div className="relative grid grid-cols-5 gap-4">
              {roadmap.map((step, idx) => (
                <Reveal key={step.id} delay={idx * 70}>
                  <div className="flex flex-col items-center text-center">
                    <div className="relative z-10 w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500 text-foreground-950">
                      <i className={`${step.icon} text-lg`}></i>
                    </div>
                    <div className="mt-3 text-xs font-semibold text-secondary-700 whitespace-nowrap">
                      第 {idx + 1} 步 · {step.phase}
                    </div>
                    <div className="mt-1.5 text-sm font-semibold text-foreground-900">{step.title}</div>
                    <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        {/* 移动端：纵向步骤 */}
        <div className="lg:hidden mt-10 space-y-4">
          {roadmap.map((step, idx) => (
            <Reveal key={step.id} delay={idx * 40}>
              <div className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-500 text-foreground-950 flex-shrink-0">
                  <i className={`${step.icon} text-lg`}></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-secondary-700">
                    第 {idx + 1} 步 · {step.phase}
                  </div>
                  <div className="mt-1 text-sm font-semibold text-foreground-900">{step.title}</div>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}